import React, { useEffect, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectIsLoading,
  makeSelectListMultipleChoiceQuestions,
} from "./selectors"
import { getListMultipleChoiceQuestionsWatcher } from "./actions"

import { Spin, Select } from "antd"
import { validate } from "../../../utils/functions"
import HorizontalBarMultipleAnswer from "../../../Reports/components/ReChart/HorizontalBarMultipleAnswer"
import PieChartSingleAnswer from "../../../Reports/components/ReChart/PieChartSingleAnswer"
import LegendPieChart from "../../../Reports/components/LegendPieChart"
import { Link } from "react-router-dom"
import { loadTexts } from "../../../utils/i18n"

import "../../../Reports/components/WidgetMultipleChoiceQuestions/index.less"

const { Option } = Select

export function WidgetMultipleChoiceQuestions(props) {
  const intlWidgetMultipleChoice = loadTexts("reports_general_view")
    .reportAmbassador.engagementMeasurement.widgetMultipleChoices
  const [idQuestionSelect, setIdQuestionSelect] = useState(null)
  const [questionSelect, setQuestionSelect] = useState(null)

  useEffect(() => {
    initGetData()
  }, [props.idMeasure, props.idDivisionSelected, props.selectedSegment])

  useEffect(() => {
    if (
      validate.exist(props.listMultipleChoiceQuestions) &&
      props.listMultipleChoiceQuestions.length > 0
    ) {
      setIdQuestionSelect(props.listMultipleChoiceQuestions[0].id_question)
      setQuestionSelect(props.listMultipleChoiceQuestions[0])
    }
  }, [props.listMultipleChoiceQuestions])

  const initGetData = () => {
    const {
      idMeasure,
      getListMultipleChoiceQuestions,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props

    if (!validate.exist(measureGeneral)) return

    const params = {
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      id_segment: selectedSegment,
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    }
    getListMultipleChoiceQuestions(params)
  }

  const renderHeader = () => {
    const isAmbassador =
      props.idDivisionSelected || props.idDivisionParent
        ? `&id_division=${props.idDivisionSelected || props.idDivisionParent}`
        : ""

    let parentDivision = ""
    if (props.idDivisionParent && props.idDivisionSelected) {
      parentDivision = `&id_divisionParent=${props.idDivisionParent}`
    }

    let paramSegment = ""
    if (!validate.empty(props.selectedSegment)) {
      paramSegment = `&id_segment=${props.selectedSegment}`
    }

    return (
      <div className="WidgetMultipleChoiceQuestions__Header">
        <div className="WidgetMultipleChoiceQuestions__Header--title">
          {intlWidgetMultipleChoice.title}
        </div>
        <div className="WidgetMultipleChoiceQuestions__Header--link">
          <span>
            <Link
              to={`/reports/measure/${props.idMeasure}/multiple-choice-question?f${isAmbassador}${parentDivision}${paramSegment}`}
            >
              {intlWidgetMultipleChoice.link}
            </Link>
          </span>
        </div>
      </div>
    )
  }

  const renderContent = () => {
    const { listMultipleChoiceQuestions } = props
    return (
      <div className="WidgetMultipleChoiceQuestions__Content">
        <div className="WidgetMultipleChoiceQuestions__Content__Header">
          <div className="WidgetMultipleChoiceQuestions__Content__Header--select">
            <Select
              value={idQuestionSelect}
              style={{ width: 756 }}
              onChange={handleChangeQuestion}
            >
              {listMultipleChoiceQuestions.map((row) => {
                return (
                  <Option value={row.id_question} key={row.id_question}>
                    {row.question_name}
                  </Option>
                )
              })}
            </Select>
          </div>
          <div className="WidgetMultipleChoiceQuestions__Content__Header--info">
            <span>
              <strong>{intlWidgetMultipleChoice.contentTitle}</strong>:{" "}
              {questionSelect && questionSelect.multiple_responses
                ? intlWidgetMultipleChoice.typeMultiple
                : intlWidgetMultipleChoice.typeUnique}
            </span>{" "}
            |{" "}
            <span>
              <strong>{intlWidgetMultipleChoice.answers}</strong>:{" "}
              {questionSelect && questionSelect.options
                ? questionSelect.options
                    .map((item) => item.employees)
                    .reduce(
                      (previousValue, currentValue) =>
                        previousValue + currentValue
                    )
                : 0}
            </span>
          </div>
        </div>
        <div className="WidgetMultipleChoiceQuestions__Content__Chart">
          {questionSelect && questionSelect.multiple_responses
            ? renderChartMultipleAnswer()
            : renderChartSingleAnswer()}
        </div>
      </div>
    )
  }

  const renderChartMultipleAnswer = () => {
    if (
      !validate.exist(questionSelect) ||
      !validate.exist(questionSelect.options)
    ) {
      return null
    }
    return (
      <div className="WidgetMultipleChoiceQuestions__Content__BarChart">
        <HorizontalBarMultipleAnswer data={questionSelect.options} />
      </div>
    )
  }

  const renderChartSingleAnswer = () => {
    if (
      !validate.exist(questionSelect) ||
      !validate.exist(questionSelect.options)
    ) {
      return null
    }
    return (
      <div className="WidgetMultipleChoiceQuestions__Content__PieChart">
        <div className="WidgetMultipleChoiceQuestions__Content__PieChart--aux">
          <PieChartSingleAnswer data={questionSelect.options} />
          <LegendPieChart data={questionSelect.options} />
        </div>
      </div>
    )
  }

  const handleChangeQuestion = (value) => {
    setIdQuestionSelect(value)
    const data = props.listMultipleChoiceQuestions.find(
      (row) => row.id_question === value
    )
    setQuestionSelect(data)
  }

  if (props.isLoading) {
    return (
      <div className="WidgetMultipleChoiceQuestions">
        <Spin size="large" />
      </div>
    )
  }

  if (
    !validate.exist(props.listMultipleChoiceQuestions) ||
    props.listMultipleChoiceQuestions.length === 0
  ) {
    return null
  }

  return (
    <div className="WidgetMultipleChoiceQuestions">
      {renderHeader()}
      {renderContent()}
    </div>
  )
}

WidgetMultipleChoiceQuestions.propTypes = {
  isLoading: PropTypes.bool,
  listMultipleChoiceQuestions: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]),
  getListMultipleChoiceQuestions: PropTypes.func,
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  listMultipleChoiceQuestions: makeSelectListMultipleChoiceQuestions(),
})

function mapDispatchToProps(dispatch) {
  return {
    getListMultipleChoiceQuestions: (params) =>
      dispatch(getListMultipleChoiceQuestionsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({
  key: "widgetMultipleChoiceQuestionsV2",
  reducer,
})
const withSaga = injectSaga({ key: "widgetMultipleChoiceQuestionsV2", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetMultipleChoiceQuestions)
